import { useAPIQuery as o } from "./index.es385.js";
const u = ({ environment: e, token: r }) => o({
  queryKey: ["categories"],
  token: r,
  environment: e,
  queryFn: async (t) => {
    const { getCategories: s } = t;
    return (await s()).data;
  }
});
export {
  u as useGetCategories
};
//# sourceMappingURL=index.es387.js.map
